import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal'
import io from 'socket.io-client';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PdfTemplates from '../../pdfs/pdf_templates';

import '../../css/SingleScreens/ConsultationScreen.css';

import config from '../../config';
import { StringUtils, DateUtils, ArrayUtils } from '../../utils';
import { History as history, Routes as routes } from '../../navigation';
import { UserActions, ContextActions, PracticeActions, ConsultationsActions, VideoCallActions, NotificationsActions, ScheduleActions } from '../../actions';
import { TitleBar, SingleScreenNavBar, VideoCall, Button, AppointmentIcon } from  '../../components'

class ConsultationScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'messages', // 'messages' 'details' 'more'
      messages: [],
      message: '',
      file: null,
      toUpload: null,
      attachmentType: '',
      displayCall: false,
      displayAppointmentModal: false,
      appointment: { new: true, time: this.getRoundedDate(), duration: 10 },
      appointments_dict: {},
      recently_assigned: false,
      modal_image_url: '',
      display_image_modal: false,
    }

    this.socket = null;
  }

  getRoundedDate = () => {
    let current_time = new Date();
    current_time.setMinutes(0);
    let new_time = current_time - 3600000;
    new_time = new_time + 3600000 + 3600000;
    return new_time;
  }

  socket_connect(consultationID) {
    return io(config.CHAT_URL, {
        path: '/chat',
        query: 'consultation_id=' + consultationID
    });
  }

  componentWillUnmount() {
    const consultation = this.props.consultations && this.props.consultations.selectedConsultation ? this.props.consultations.selectedConsultation : {};
    const consultationID = consultation._id;
    const token = this.props.user.auth.token;

    if (this.socket) {
      this.socket.emit('end');
    }
    if (consultationID && token) {
      this.props.consultationsActions.getConsultationInfo(token, consultationID);
    }
  }

  componentDidMount() {
    const consultation = this.props.consultations && this.props.consultations.selectedConsultation ? this.props.consultations.selectedConsultation : {};
    const consultationID = consultation._id;
    const notificationsDict = this.props.notifications && this.props.notifications.notificationsConsultationsDict ? this.props.notifications.notificationsConsultationsDict : {};
    const token = this.props.user.auth.token;

    // this.props.scheduleActions.getPracticeAppointments(token, consultation.practice_id);
    this.props.scheduleActions.getConsultationAppointments(token, consultationID, this.updateConsultationAppointments);

    this.socket = this.socket_connect(consultationID);

    this.socket.on('chat message', (msg) => {
      let allMessages = this.state.messages;
      const latestMessageText = msg && msg.content && msg.content.text ? msg.content.text : '';
      const latestMessageIsMine = this.state.message === latestMessageText;

      if (msg && msg.type === 'APPOINTMENT') {
        this.props.scheduleActions.getConsultationAppointments(token, consultationID, this.updateConsultationAppointments);
      }

      allMessages.push(msg);
      this.setState({
        messages: allMessages,
        message: this.state.message === '' || latestMessageIsMine ? '' : this.state.message,
      });
    });

    this.props.videoCallActions.getVideoCallToken(token, consultationID);
    this.props.consultationsActions.fetchOpenConsultationMessages(token, consultationID, this.consultationMessagesLoadedSuccess);
    this.props.consultationsActions.getConsultationMedicalRecords(token, consultationID);
    this.props.consultationsActions.getConsultationFrontDeskTasks(token, consultationID);

    if (notificationsDict[consultationID] && token) {
      this.props.notificationsActions.markConsultationNotificationsRead(token, consultationID);
    }

    const selectedTab = this.props.consultations && this.props.consultations.selectedTab ? this.props.consultations.selectedTab : 'messages';
    this.setState({ ...this.state, activeTab: selectedTab });
  }

  consultationMessagesLoadedSuccess = (messages) => {
    this.setState({ ...this.state, messages: messages })
  }

  renderBottomSectionTabs = () => {
    return <div className="flex-container flex-container-row consultation-screen-bottom-tab-container">
      <div className="flex-container consultation-screen-bottom-tab-button">
        <span className={`consultation-screen-bottom-tab-button-title${this.state.activeTab === 'messages' ? '-selected' : ''}`}
              onClick={ () => {
                this.props.consultationsActions.switchConsultationTab('messages')
                this.setState({ ...this.state, activeTab: 'messages' })
              }}>
          Messages
        </span>
      </div>
      <div className="flex-container consultation-screen-bottom-tab-button">
        <span className={`consultation-screen-bottom-tab-button-title${this.state.activeTab === 'details' ? '-selected' : ''}`}
              onClick={ () => {
                this.props.consultationsActions.switchConsultationTab('details')
                this.setState({ ...this.state, activeTab: 'details' })
              }}>
          Details
        </span>
      </div>
      <div className="flex-container consultation-screen-bottom-tab-button">
        <span className={`consultation-screen-bottom-tab-button-title${this.state.activeTab === 'more' ? '-selected' : ''}`}
              onClick={ () => {
                this.props.consultationsActions.switchConsultationTab('more')
                this.setState({ ...this.state, activeTab: 'more' })
              }}>
          More
        </span>
      </div>
    </div>
  }

  renderFrontDeskSection = (consultation) => {
    const isResolved   = consultation.status === 'RESOLVED';
    const isProcessing = consultation.status === 'PROCESSING';

    const allTasks = this.props.consultations.consultationFrontDeskTasks || {};
    const previousTasks = allTasks[consultation._id] || [];

    const allRecords = this.props.consultations.consultationMedicalRecords || {};
    const previousRecords = allRecords[consultation._id] || [];

    var practiceInfo = this.props.practice && this.props.practice.info ? this.props.practice.info : null;
    var practice_id  = consultation.practice_id || '';
    var isBehavior   = false;

    let practice_code      = practiceInfo && practiceInfo.code ? practiceInfo.code : 'NO_CODE';
    let display_recordings = practice_code.toUpperCase() === 'CCAH' && isResolved ? true : false;

    if (practiceInfo && practiceInfo.type === 'BEHAVIOR' && practiceInfo._id === practice_id) {
      isBehavior = true;
    }

    return <div className="flex-container flex-container-column">
      <div className='flex-container-column' style={{ padding: 15 }}>

      { isResolved || isProcessing ? null
        : <div className='flex-container-column' style={{ marginTop: 10, marginBottom: 10 }}>
          <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <div className='flex-container-column'>
              <span style={{ fontSize: 20 }}>Resolve Consultation</span>
              <span style={{ fontSize: 14, color: 'grey', marginTop: -3 }}>Resolve the consultation and set payment amount.</span>
            </div>
            <div>
              <input type='submit'
                     className='button-default'
                     value='Resolve'
                     onClick={ () => {
                       const screenProps = {
                         option: 'resolve',
                       }
                       history.push({ pathname: routes.CONSULTATION_OPTIONS, state: { props: screenProps } })
                     }}
                    />
            </div>
          </div>
        </div> }

        { isResolved || isProcessing ? null : <div style={{ backgroundColor: '#e7e7e7', height: 1, marginTop: 15 }}></div> }

          <div className='flex-container-column' style={{ marginTop: isResolved || isProcessing ? 10 : 25, marginBottom: 10 }}>
            <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <div className='flex-container-column'>
                <span style={{ fontSize: 20 }}>Front Desk Task</span>
                <span style={{ fontSize: 14, color: 'grey', marginTop: -3 }}>Create and send a task to the front desk.</span>
              </div>
              <div>
                <input type='submit'
                       className='button-default'
                       value='Create & Send Task'
                       onClick={ () => {
                         const screenProps = {
                           option: 'front_desk',
                         }
                         history.push({ pathname: routes.CONSULTATION_OPTIONS, state: { props: screenProps } })
                       }}
                      />
              </div>
            </div>
            { this.renderPreviousTasks(previousTasks) }
          </div>

        <div style={{ backgroundColor: '#e7e7e7', height: 1, marginTop: 15 }}></div>

          <div className='flex-container-column' style={{ marginTop: 25, marginBottom: 10 }}>
            <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <div className='flex-container-column'>
                <span style={{ fontSize: 20 }}>{ isBehavior ? 'Note' : 'Medical Record' }</span>
                <span style={{ fontSize: 14, color: 'grey', marginTop: -3 }}>Add a { isBehavior ? 'note' : 'medical record' } to this consultation.</span>
              </div>
              <div>
                <input type='submit'
                       className='button-default'
                       value={ isBehavior ? 'Create Note' : 'Create Record' }
                       onClick={ () => {
                         const screenProps = {
                           option: 'medical_record',
                         }
                         history.push({ pathname: routes.CONSULTATION_OPTIONS, state: { props: screenProps } })
                       }}
                      />
              </div>
            </div>
            { this.renderPreviousRecords(previousRecords, consultation) }
          </div>

        <div style={{ backgroundColor: '#e7e7e7', height: 1, marginTop: 15 }}></div>

        { display_recordings ? <div className='flex-container-column' style={{ marginTop: 25, marginBottom: 10 }}>
          <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <div className='flex-container-column'>
              <span style={{ fontSize: 20 }}>{ 'Consultation Recordings' }</span>
              <span style={{ fontSize: 14, color: 'grey', marginTop: -3 }}>Process consultation video recordings.</span>
            </div>
            <div>
              <input type='submit'
                     className='button-default'
                     value={ 'View Recordings' }
                     onClick={ () => {
                       const screen_props = {
                         consultation: consultation,
                       }
                       history.push({ pathname: routes.CONSULTATION_RECORDINGS, state: { props: screen_props } })
                     }}
                    />
            </div>
          </div>
        </div> : null }

      </div>
    </div>
  }

  renderPreviousTasks = (tasks) => {
    if (!tasks || tasks.length === 0) {
      return null;
    }

    const taskRows = tasks.map((task) => {
      const subject   = task.subject;
      const message   = task.message;
      const completed = task.completed ? true : false;
      const iconName  = completed ? 'check-circle' : 'hourglass-start';
      const iconColor = completed ? '#66D56F' : 'orange';
      if (subject && message) {
        return <div className='flex-container-row' key={task._id} style={{ marginTop: 10, alignItems: 'center', justifyContent: 'space-between' }}>
          <div className='flex-container-column'>
            <span className='contsultation-fd-task-message-span' style={{ fontSize: 14, color: '#5d5d5d', fontWeight: 'bold' }}>{ subject }</span>
            <span className='contsultation-fd-task-message-span' style={{ fontSize: 14, color: 'grey', marginTop: 0 }}>{ message }</span>
          </div>
          <div className='flex-container-column'>
            <span className={'fas fa-' + iconName} style={{ fontSize: 18, color: iconColor }}></span>
          </div>
        </div>
      }
    }).filter((row) => { return row });

    return <div className='flex-container-column' style={{ marginTop: 10 }}>
      { taskRows }
    </div>
  }

  renderPreviousRecords = (records, consultation) => {
    if (!records || records.length === 0) {
      return null;
    }

    var practiceInfo = this.props.practice && this.props.practice.info ? this.props.practice.info : null;
    var practice_id  = consultation.practice_id || '';
    var isBehavior   = false;

    if (practiceInfo && practiceInfo.type === 'BEHAVIOR' && practiceInfo._id === practice_id) {
      isBehavior = true;
    }

    const recordRows = records.map((record) => {
      const defaultTitle = isBehavior ? 'Note' : 'Medical Record';
      const subject   = record.subject || defaultTitle;
      const body      = record.body;
      const completed = record.completed ? true : false;
      if (subject && body) {
        return <div className='flex-container-column' key={record._id} style={{ marginTop: 10 }}>
          <span className='contsultation-record-body-span' style={{ fontSize: 14, color: '#5d5d5d', fontWeight: 'bold' }}>{ subject }</span>
          <span className='contsultation-record-body-span' style={{ fontSize: 14, color: 'grey', marginTop: 0 }}>{ body }</span>
        </div>
      }
    }).filter((row) => { return row });

    return <div className='flex-container-column' style={{ marginTop: 10 }}>
      { recordRows }
    </div>
  }

  renderDetailsSection = (consultation) => {
    const primaryProvider = consultation.primaryProvider;
    const primaryClient   = consultation.primaryClient;
    const patient         = consultation.patient;
    const providerName    = StringUtils.displayName(primaryProvider);
    const location_id     = consultation.location_id || '';
    const locationInfo    = this.getLocationInfo(location_id);
    const hideReassign    = consultation.status !== 'ACTIVE' ? true : false;
    return <div className="flex-container flex-container-column">
      <div>
        { locationInfo ? <div className="flex-container flex-container-column" style={{ padding: 15, paddingTop: 20 }}>
          <span className="consultation-details-title">PRACTICE LOCATION</span>
          <span className="consultation-details-name-text" style={{ marginLeft: 0 }}>{ locationInfo.name }</span>
          <span className="consultation-details-name-text" style={{ color: 'grey', marginLeft: 0 }}>{ locationInfo.street_address }</span>
          <span className="consultation-details-name-text" style={{ color: 'grey', marginLeft: 0 }}>{ locationInfo.city + ', ' + locationInfo.state + ' ' + locationInfo.zipcode }</span>
        </div> : null }
        <div className="flex-container flex-container-row flex-space-between" style={{ padding: 15, paddingTop: 15 }}>
          <div className="flex-container flex-container-column">
            <span className="consultation-details-title">CLIENT & PATIENT</span>
            <div className="flex-container flex-container-row" style={{ alignItems: 'center', marginBottom: 5 }}>
              { primaryClient.photo_url ? <img className="image-default" alt='Profile Pic of Client' style={{ height: 30, width: 30, borderRadius: 15 }} src={primaryClient.photo_url} />
              : <span className="fas fa-user-circle" style={{ fontSize: 30, color: '#e9e9e9' }}></span> }

              <span className="consultation-details-name-text">{ StringUtils.displayName(primaryClient) }</span>
            </div>
            <div className="flex-container flex-container-row" style={{ alignItems: 'center' }}>
              { patient.photo_url ? <img className="image-default" alt='Profile Pic of Patient' style={{ height: 30, width: 30, borderRadius: 15 }} src={patient.photo_url} />
              : <span className="fas fa-user-circle" style={{ fontSize: 30, color: '#e9e9e9' }}></span> }
              <span className="consultation-details-name-text">{ StringUtils.displayName(patient) }</span>
            </div>
          </div>
          <div className="flex-container flex-container-column" style={{ alignItems: 'flex-end'}}>
            <span className="consultation-details-title">PROVIDER</span>
            <div className="flex-container flex-container-row" style={{ alignItems: 'center' }}>
              { primaryProvider.photo_url ? <img className="image-default" alt='Profile Pic of Provider' style={{ height: 30, width: 30, borderRadius: 15 }} src={primaryProvider.photo_url} />
              : <span className="fas fa-user-circle" style={{ fontSize: 30, color: '#e9e9e9' }}></span> }
              <span className="consultation-details-name-text">{ providerName }</span>

            </div>
            { hideReassign ? null : <div className="flex-container flex-container-column">
              <span className="button-clear-blue"
                    style={{ color: '#1dc2ff', alignSelf: 'flex-end', paddingTop: 3, paddingBottom: 3, marginTop: 5 }}
                    onClick={ () => {
                      this.props.practiceActions.openReassignConsultation()
                    }}>
                    Reassign
              </span>
            </div> }
          </div>
        </div>

        { this.renderConsultationParticipantsList(consultation) }

      </div>
    </div>
  }

  renderConsultationParticipantsList = (consultation) => {

    const participants = this.props.consultations
                         && this.props.consultations.consultationParticipants
                         && this.props.consultations.consultationParticipants[consultation._id]
                         ?  this.props.consultations.consultationParticipants[consultation._id] : [];

    const userId  = this.props.user.auth.user_id;
    const isAdmin = this.props.context && this.props.context.selectedRole === 'admin';

    const participantRows = participants.map((participant) => {
      const participantInfo = participant;
      if (participantInfo) {
        return <div key={participantInfo._id} className="flex-container flex-container-row flex-space-between flex-center-align" style={{ marginBottom: 5, paddingTop: 3, paddingBottom: 3 }}>
                <div className="flex-container flex-container-row flex-center-align">
                  { participantInfo.photo_url ? <img className="image-default" alt='Profile Pic of Patient' style={{ height: 30, width: 30, borderRadius: 15 }} src={participantInfo.photo_url} />
                  : <span className="fas fa-user-circle" style={{ fontSize: 30, color: '#e9e9e9' }}></span> }
                  <span className="consultation-details-name-text">{ StringUtils.displayName(participantInfo) }</span>
                </div>
                <div>
                  { (userId === consultation.primary_assignee || isAdmin)
                  ? <div className="flex-container-column button-clear-blue"
                         style={{ justifyContent: 'center', alignItems: 'center' }}
                         onClick={ () => {
                          this.props.consultationsActions.removeConsultationParticipant(this.props.user.auth.token, consultation._id, participant);
                         }}>
                         <span className="fas fa-user-minus" style={{ fontSize: 14 }}></span>
                      </div>
                  : null }
                </div>
               </div>
      } else { return null }
    }).filter((row) => { return row });


    const displayNoParticipants = participantRows.length === 0 ;

    return  <div className="flex-container flex-container-row flex-space-between" style={{ padding: 15, paddingRight: 10 }}>
              <div className="flex-container flex-container-column" style={{ width: '100%' }}>
                <div className="flex-container flex-container-row flex-space-between flex-center-align">
                  <span className="consultation-details-title" style={{ marginTop: 10 }}>OTHER PARTICIPANTS</span>
                  <span className="button-clear-blue" style={{ color: '#1dc2ff' }} onClick={ () => { history.push(routes.CONSULTATION_ADD_PARTICIPANT) }}>
                    <span className="fas fa-user-plus" style={{ marginRight: 8 }}></span>ADD PARTICIPANT
                  </span>
                </div>
                { displayNoParticipants ? <div className="flex-container flex-container-row" style={{ alignItems: 'center', marginTop: 15, justifyContent: 'center', fontSize: 14, color: 'grey' }}>
                                            This consultation currently has no other participants
                                          </div>
                                          : null }
                { participantRows }
              </div>
            </div>
  }

  renderMediaPreviewSection = () => {

    if (this.state.attachmentType === '') {
      return <div>Format not supported
                <input type="submit"
                   className="button-clear"
                   value="Cancel"
                   style={{ marginRight: 5, marginBottom: 10 }}
                   onClick={ () => { this.setState({ ...this.state, file: null, toUpload: null }) }}
                  />
              </div>
    }

    const imageComponent = <img className="consultation-attachment-input-image-preview" alt='Message Attachment' width="200" src={this.state.file} />
    const videoComponent = <video className="consultation-attachment-input-video-preview" controls width="auto" height="auto">
              <source src={this.state.file} type="video/mp4" />
              Sorry, your browser doesn't support this video format.
            </video>

    return <div className="flex-container flex-container-column flex-center-align">

        { this.state.attachmentType === 'IMAGE' ? imageComponent : null }
        { this.state.attachmentType === 'VIDEO' ? videoComponent : null }

        <div className="flex-container">
          <input type="submit"
                 className="button-clear"
                 value="Cancel"
                 style={{ marginRight: 5, marginBottom: 20 }}
                 onClick={ () => { this.setState({ ...this.state, file: null, toUpload: null, attachmentType: '' }) }}
                />
          <div>
          <input type="submit"
                 className="button-default"
                 value="Send"
                 onClick={ () => { this.submitFile() }}
                />
          </div>
        </div>
      </div>
  }

  renderMessagesSection = (consultation) => {

    var displayImageInput = this.state.file ? true : false;
    var isResolved   = consultation.status === 'RESOLVED';
    var isProcessing = consultation.status === 'PROCESSING';
    var messages = this.state.messages.slice() || [];
    var ordered  = messages.reverse();
    var messageRows = ordered.map((message) => {
      return this.renderMessageRow(message);
    })

    return <div className="flex-container flex-container-column">
      <div className="consultations-message-scoll-view">
        { messageRows }
        <div style={{ height: 10 }}>
          <div style={{ height: 10, width: 10 }}></div>
        </div>
      </div>

      { isResolved || isProcessing
      ? <div className='flex-container' style={{ paddingTop: 12, paddingLeft: 10, alignItems: 'center' }}>
          { isProcessing ? null : <span className="fas fa-check-circle" style={{ fontSize: 25, color: '#75D392', marginRight: 5 }}></span> }
          <span style={{ color: isProcessing ? 'orange' : 'grey' }}>{ isProcessing ? 'Processing' : 'Consultation Resolved' } </span>
        </div>
      :<div className="consultations-message-input-container">
        { displayImageInput
        ? this.renderMediaPreviewSection()
        : <div className="flex-container">
            <textarea
                placeholder="Enter a New Message..."
                rows="3"
                type="text"
                name="message"
                className="consultations-message-input"
                value={this.state.message}
                onChange={(event) => { this.setState({ ...this.state, message: event.target.value  }) }}
              >
              </textarea>
          </div>
        }

        { displayImageInput ? null
        :<div className="flex-container" style={{ padding: 10, justifyContent: 'space-between' }}>
          <div className='flex-container-row'>
            <input className="consultation-file-upload-input"
                   type='file'
                   id="file-upload"
                   onChange={ (event) => { this.handleFileUpload(event) }}
                  />
            <label className="button-default flex-container" htmlFor="file-upload" style={{ alignItems: 'center', justifyContent: 'center', height: 40, width: 40, borderRadius: 20 }}><span className="fas fa-paperclip" style={{ fontSize: 18, color: 'white' }}></span></label>

            <input className='consultation-file-upload-input' id='video-call-button' onClick={ () => { this.toggleDisplayCall() }} />
            <label className="button-default flex-container" htmlFor="video-call-button" style={{ marginLeft: 5, alignItems: 'center', justifyContent: 'center', height: 40, width: 40, borderRadius: 20 }}><span className="fas fa-video" style={{ fontSize: 18, color: 'white' }}></span></label>

            <input className='consultation-file-upload-input' id='appointment-button' onClick={ () => { this.setState({ ...this.state, displayAppointmentModal: true, appointment: { new: true, time: this.getRoundedDate(), duration: 10 } }) }} />
            <label className="button-default flex-container" htmlFor="appointment-button" style={{ marginLeft: 5, alignItems: 'center', justifyContent: 'center', height: 40, width: 40, borderRadius: 20 }}><span className="far fa-calendar-alt" style={{ fontSize: 20, color: 'white' }}></span></label>

          </div>
          <div>

          <input type="submit"
                 className="button-default"
                 value="Send"
                 onClick={ () => { this.sendMessage() }}
                />

          </div>
        </div> }

      </div> }
    </div>
  }

  renderMessageRow = (message) => {
    if (!message) {
      return null;
    }

    const userID = this.props.user.auth.user_id;
    var sentBySelf = message && message.from && userID === message.from._id ? true : false;
    var messageComponent = null;
    var sentMessageImage = null;
    var senderProfile = message && message.from && this.props.user.users && this.props.user.users[message.from._id] ? this.props.user.users[message.from._id] : message.from;
        senderProfile = senderProfile || {};
    var startDateString = DateUtils.getShortMonth(message.created_at) + ' ' + DateUtils.getDateNumber(message.created_at) + ', ' + DateUtils.getTime(message.created_at);

    if (message.type === "IMAGE") {
      const imageURL = message.content.url;
      messageComponent =  <div style={{ marginTop: 2 }}
                               className="consultation-image-message-container image-expand-button"
                               onClick={ () => {
                                 this.setState({ ...this.state, modal_image_url: imageURL, display_image_modal: true });
                               }}>
                            { !sentBySelf && senderProfile.first_name ? <div style={{ fontWeight: 'bold', color: '#1dc2ff', fontSize: 12, padding: 5, paddingLeft: 10, backgroundColor: 'white' }}>{ StringUtils.displayName(senderProfile) }</div> : null }
                            <img className="consultation-message-image" alt='Message Attachment' style={{ margin: 0 }} src={imageURL} />
                            <div style={{ marginLeft: 8, marginTop: 4, marginBottom: 4, fontSize: 10, color: '#999999' }}>{ startDateString }</div>
                          </div>
    }

    if (message.type === "TEXT") {
      messageComponent =  <span className={`consultation-message-text-span-${sentBySelf ? 'sent' : 'received'}`}>
                            { !sentBySelf && senderProfile.first_name ? <div style={{ fontWeight: 'bold', color: '#1dc2ff', fontSize: 12 }}>{ StringUtils.displayName(senderProfile) }</div> : null }
                            { message.content.text }
                            <div style={{ fontSize: 10, color: sentBySelf ? 'white' : '#999999' }}>{ startDateString }</div>
                          </span>
    }

    if (message.type === "VIDEO") {
      const videoURL = message.content.url;
      messageComponent =  <div className="consultation-image-message-container">
                            { !sentBySelf && senderProfile.first_name ? <div style={{ fontWeight: 'bold', color: '#1dc2ff', fontSize: 12, padding: 5, paddingLeft: 10, backgroundColor: 'white' }}>{ StringUtils.displayName(senderProfile) }</div> : null }
                            <video className="consultation-message-video" controls width="auto" height="auto">
                              <source src={videoURL} type="video/mp4" />
                              Sorry, your browser doesn't support this video format.
                            </video>
                            <div style={{ marginLeft: 8, marginTop: 4, marginBottom: 4, fontSize: 10, color: '#999999' }}>{ startDateString }</div>
                          </div>
    }

    if (message.type === 'APPOINTMENT') {
      let appointment_id = message.content.appointment_id || '';
      let appointment    = this.state.appointments_dict[appointment_id] || null;
      if (appointment) {
        let status_upcoming  = appointment.status === 'UPCOMING'  ? true       : false;
        let status_dot_color = appointment.status === 'UPCOMING'  ? '#66D56F'  : 'white';
            status_dot_color = appointment.status === 'CANCELLED' ? 'red'      : status_dot_color;
            status_dot_color = appointment.status === 'COMPLETED' ? '#1dc2ff'  : status_dot_color;
        let title_color      = appointment.status === 'CANCELLED' ? 'red'      : '#1dc2ff';
        let title_text       = appointment.status === 'CANCELLED' ? 'Cancelled Appointment': 'Scheduled Appointment';
            title_text       = appointment.status === 'COMPLETED' ? 'Completed Appointment': title_text;
        let display_edit     = appointment.status === 'UPCOMING'  ? true : false;
        return <div key={message._id} className="consultation-appointment-overall-container" style={{ alignItems: 'center', marginTop: 5, marginBottom: 5 }}>
                  <div className={`flex-container-column ${ status_upcoming ? 'consultation-appointment-message-container' : 'consultation-appointment-message-container-read-only' }`} style={{ width: 300, borderStyle: 'solid', borderWidth: 2, borderRadius: 10, backgroundColor: 'white', overflow: 'hidden' }}
                       onClick={ () => {
                         let edit_apt  = Object.assign({}, appointment);
                         edit_apt.new  = false;
                         edit_apt.time = new Date(appointment.time);
                         edit_apt.duration = edit_apt.duration || 10;
                         this.setState({ ...this.state, appointment: edit_apt, displayAppointmentModal: true })
                       }}>
                    <div className='flex-container-row' style={{ justifyContent: 'space-between' }}>
                      <div style={{ fontWeight: 'bold', color: title_color, fontSize: 12, padding: 5, paddingLeft: 10 }}>{ title_text }</div>
                      <div style={{ backgroundColor: status_dot_color, height: 10, width: 10, borderRadius: 5, marginTop: 10, marginRight: 10 }}></div>
                    </div>
                    <div className='flex-container-row' style={{ marginLeft: 10, marginBottom: 10, marginRight: 5, justifyContent: 'space-between', alignItems: 'center' }}>
                      <AppointmentIcon appointment={appointment} small={true} />
                      <div className='flex-container-column' style={{ marginRight: 10, alignItems: 'center' }}>
                        <span style={{ marginBottom: -3, fontSize: 16, color: '#a6a6a6' }}>{ appointment.duration }</span>
                        <span style={{ fontSize: 12, color: '#a6a6a6' }}>{ appointment.duration ? 'Mins' : '' }</span>
                      </div>
                    </div>
                  </div>
               </div>
      }
    }

    // if (!sentBySelf && this.props.user.users && this.props.user.users[message.from._id]) {
      // const senderProfile = this.props.user.users[message.from._id];
      // sentMessageImage = senderProfile.photo_url ? <img className="image-default" style={{ height: 30, width: 30, borderRadius: 15, alignSelf: 'flex-end', marginRight: 5 }} src={senderProfile.photo_url} /> : <span className="fas fa-user-circle" style={{ fontSize: 20, color: '#e9e9e9', alignSelf: 'flex-end', marginRight: 5 }}></span>;
    // }

    if (!messageComponent) {
      return null;
    }

    return <div key={message._id} style={{ marginTop: 5 }} className={`consultation-message-container-${sentBySelf ? 'sent' : 'received'}`}>
      { sentBySelf ? <span style={{ flex: 1 }}></span> : null }
      { sentMessageImage }
      { messageComponent }
      { sentBySelf ? null : <span style={{ flex: 1 }}></span> }
    </div>
  }

  renderBottomSection = (consultation) => {
    return <div className="flex-container basic-container consultation-screen-bottom-container" style={{ marginBottom: 200 }}>
        { this.renderBottomSectionTabs() }
        { this.renderAppointmentModal(consultation) }
        { this.state.activeTab === 'messages'   ? this.renderMessagesSection(consultation)  : null }
        { this.state.activeTab === 'details'    ? this.renderDetailsSection(consultation)   : null }
        { this.state.activeTab === 'more'       ? this.renderFrontDeskSection(consultation) : null }
      </div>
  }

  renderAppointmentModal = (consultation) => {

    let appointment     = this.state.appointment;
    let new_appointment = this.state.appointment.new ? true : false;

    let duration        = appointment.duration || 10;

    let apt_date        = appointment.time && DateUtils.getDateNumber(appointment.time) ? DateUtils.getDateNumber(appointment.time) : '--';
    let apt_time        = appointment.time && DateUtils.getTime(appointment.time)       ? DateUtils.getTime(appointment.time) : '--';
    let apt_month       = appointment.time && DateUtils.getShortMonth(appointment.time) ? DateUtils.getShortMonth(appointment.time) : '--';

    let hour            = appointment.time ? DateUtils.getHoursString(appointment.time)   : '00';
    let minutes         = appointment.time ? DateUtils.getMinutesString(appointment.time) : '00';
    let ampm            = appointment.time ? DateUtils.getAMPMString(appointment.time)    : 'AM';
    let day             = appointment.time ? DateUtils.getLongWeekday(appointment.time)   : 'Weekday';

    let time_border_clr = appointment.time ? '#1dc2ff' : '#e7e7e7';

    let cal_date        = appointment.time ? appointment.time : new Date();
    let cal_value       = appointment.time ? apt_month + ' ' + apt_date : 'Select';

    let gc_url  = appointment && appointment.data && appointment.data.calendars && appointment.data.calendars.gc  ? appointment.data.calendars.gc  : '';
    let ics_url = appointment && appointment.data && appointment.data.calendars && appointment.data.calendars.ics ? appointment.data.calendars.ics : '';

    let is_apt_save_loading = this.props.loading && this.props.loading.saveAppointment ? true : false;

    return <Modal show={this.state.displayAppointmentModal}>
      <div className='flex-container-column' style={{ padding: 15 }}>
        <h4>New Appointment</h4>
        <div className='flex-container-column'>

        <div style={{ display: 'flex', flexDirection: 'column' }}>

          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>

            <div style={{ display: 'flex', flexDirection: 'column', marginRight: 40  }}>
              <span style={{ fontWeight: 'bold', fontSize: 12, marginBottom: 5, marginTop: 5, color: '#1dc2ff' }}>DATE</span>
              <DatePicker
                style={{ backgroundColor: 'red' }}
                selected={ cal_date }
                className={ appointment.time ? 'consultation-appointment-date-selector' : 'consultation-appointment-date-selector-empty' }
                minDate={new Date()}
                value={ cal_value }
                onChange={ (data) => {
                  let new_date = data;
                  new_date.setMinutes(0);
                  this.addHourToAppointment(new_date);
                }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontWeight: 'bold', fontSize: 12, marginBottom: 5, marginTop: 5, color: '#1dc2ff' }}>TIME</span>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', borderStyle: 'solid', borderWidth: 2, borderColor: time_border_clr, padding: 5, borderRadius: 5, height: 35, width: 80, marginRight: 5 }}>
                  <span className="fas fa-minus-circle consultation-appointment-increment-button" onClick={ () => { this.subHourFromAppointment(appointment.time) }}></span>
                  <span>{ hour }</span>
                  <span className="fas fa-plus-circle consultation-appointment-increment-button"  onClick={ () => { this.addHourToAppointment(appointment.time) }}></span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', borderStyle: 'solid', borderWidth: 2, borderColor: time_border_clr, padding: 5, borderRadius: 5, height: 35, width: 80, marginRight: 5 }}>
                  <span className="fas fa-minus-circle consultation-appointment-increment-button" onClick={ () => { this.subFiveMinsFromAppointment(appointment.time) }}></span>
                  <span>{ minutes }</span>
                  <span className="fas fa-plus-circle consultation-appointment-increment-button"  onClick={ () => { this.addFiveMinsToAppointment(appointment.time) }}></span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', borderStyle: 'solid', borderWidth: 2, borderColor: '#e7e7e7', padding: 5, borderRadius: 5, height: 35, width: 40 }}>
                  <span style={{ fontSize: 13 }}>{ ampm }</span>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontWeight: 'bold', fontSize: 12, marginBottom: 5, marginTop: 10, color: '#1dc2ff' }}>DURATION</span>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', borderStyle: 'solid', borderWidth: 2, borderColor: time_border_clr, padding: 5, borderRadius: 5, height: 35, width: 80, marginRight: 5 }}>
                  <span className="fas fa-minus-circle consultation-appointment-increment-button" onClick={ () => { this.setAppointmentDuration(duration - 5) }}></span>
                  <span>{ duration }</span>
                  <span className="fas fa-plus-circle consultation-appointment-increment-button"  onClick={ () => { this.setAppointmentDuration(duration + 5) }}></span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', borderStyle: 'solid', borderWidth: 2, borderColor: '#e7e7e7', padding: 5, borderRadius: 5, height: 35, width: 80 }}>
                  <span style={{ fontSize: 13 }}>{ 'Minutes' }</span>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ height: 1, backgroundColor: '#e7e7e7', width: '100%', marginTop: 20, marginBottom: 10, width: 330, alignSelf: 'center' }}></div>

        <div style={{ display: 'flex', flexDirection: 'row', width: 330, justifyContent: 'space-between', alignSelf: 'center', alignItems: 'center' }}>
          <AppointmentIcon appointment={appointment} style={{ alignSelf: 'center' }}/>
          { gc_url || ics_url ? <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  { gc_url  ? <a href={gc_url}  className='consultation-export-appointment-link' target='_blank'>+ Google Calendar</a>  : null }
                                  { ics_url ? <a href={ics_url} className='consultation-export-appointment-link' target='_blank'>+ Outlook & Others</a> : null }
                                </div>
                              : <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                  <span style={{ color: 'grey', fontSize: 18 }}>{ duration }</span>
                                  <span style={{ color: 'grey', fontSize: 12, marginTop: -3 }}>Mins</span>
                                </div> }
        </div>

        </div>
        <div className='flex-container-row' style={{ justifyContent: 'space-between', marginTop: 10, alignItems: 'center' }}>
          <div>
            { new_appointment ? null : <Button value='Cancel Appointment'
                                               className='button-clear-blue'
                                               style={{ marginRight: 5, color: 'red' }}
                                               onClick={ () => {
                                                 let token            = this.props.user.auth.token;
                                                 let apt_to_cancel    = Object.assign({}, appointment);
                                                 let consult_id       = consultation && consultation._id ? consultation._id              : '';
                                                 apt_to_cancel.status = 'CANCELLED';
                                                 this.props.scheduleActions.updateAppointment(token, apt_to_cancel, () => { this.closeAppointmentModal(token, consult_id) });
                                               }}/> }
          </div>
          <div className='flex-container-row' style={{ justifyContent: 'flex-end', alignItems: 'center' }}>
            <Button value='Cancel' className='button-clear-blue' style={{ marginRight: 5 }} onClick={ () => { this.setState({ ...this.state, displayAppointmentModal: false }) } }/>
            <Button value={ new_appointment ? 'Create' : 'Save Changes' }
                    loading={ is_apt_save_loading }
                    onClick={ () => {
                      let token        = this.props.user.auth.token;
                      let consult_id   = consultation && consultation._id              ? consultation._id              : '';
                      let assignee     = consultation && consultation.primary_assignee ? consultation.primary_assignee : '';
                      let client       = consultation && consultation.primary_client   ? consultation.primary_client   : '';
                      let participants = [assignee, client];
                      let time_mills   = appointment  && appointment.time ? appointment.time : 0;
                      let final_date   = new Date(time_mills);
                      final_date.setSeconds(0);
                      final_date.setMilliseconds(0);
                      let date_str     = final_date.toString();
                      let duration     = appointment  && appointment.duration ? appointment.duration : 10;

                      if (token && consult_id) {
                        let apt = {
                          consultation_id: consult_id,
                          time: date_str,
                          duration: duration,
                          data: {
                            participants: participants,
                          }
                        }

                        if (new_appointment) {
                          this.props.scheduleActions.addAppointment(token, apt, () => { this.closeAppointmentModal(token, consult_id) });
                        } else {
                          apt._id = appointment._id || '';
                          this.props.scheduleActions.updateAppointment(token, apt, () => { this.closeAppointmentModal(token, consult_id) });
                        }
                      }

                    }}/>
          </div>
        </div>
      </div>
    </Modal>
  }

  setAppointmentDuration = (duration) => {
    let new_duration = duration;
    let new_apt  = Object.assign({}, this.state.appointment);
    if (duration > 0) {
      new_apt.duration = new_duration;
    }
    this.setState({ ...this.state, appointment: new_apt });
  }

  subHourFromAppointment = (dateTime) => {
    let current_time = dateTime;
    let new_time = current_time - 3600000;
    let new_apt  = Object.assign({}, this.state.appointment);
    new_apt.time = new_time;
    this.setState({ ...this.state, appointment: new_apt });
  }

  addHourToAppointment = (dateTime) => {
    let current_time = dateTime;
    let new_time = current_time - 3600000;
    new_time = new_time + 3600000 + 3600000;
    let new_apt  = Object.assign({}, this.state.appointment);
    new_apt.time = new_time;
    this.setState({ ...this.state, appointment: new_apt });
  }

  subFiveMinsFromAppointment = (dateTime) => {
    let current_time = dateTime;
    let new_time = current_time - (60000 * 5);
    let new_apt  = Object.assign({}, this.state.appointment);
    new_apt.time = new_time;
    this.setState({ ...this.state, appointment: new_apt });
  }

  addFiveMinsToAppointment = (dateTime) => {
    let current_time = dateTime;
    let new_time = current_time - (60000 * 5);
    new_time = new_time + (60000 * 5) + (60000 * 5);
    let new_apt  = Object.assign({}, this.state.appointment);
    new_apt.time = new_time;
    this.setState({ ...this.state, appointment: new_apt });
  }

  renderAssignProviderSection = (consultation) => {
    let rencently_assigned = this.state.recently_assigned === true ? true : false;
    let display_section    = rencently_assigned || consultation && consultation.primary_assignee === 'unassigned' ? true : false;

    if (!display_section || !consultation) {
      return null;
    }

    let section_title = rencently_assigned ? 'Provider Assigned' : 'Assign a provider';
    let provider_asnd = consultation.primary_assignee !== 'unassigned' ? true : false;
    return <div className="basic-container">
      <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <h5>{ section_title }</h5>
        <span className='fas fa-check-circle' style={{ color: provider_asnd ? '#66D56F' : 'white', fontSize: 26, marginBottom: 8, marginTop: 2 }} />
      </div>
      { provider_asnd ? null
      : <div className='flex-container-row'>
          <div className='flex-container-column'>
            <span style={{ fontSize: 14, color: 'grey' }}>This consultation does not have a provider assigned to it. Assign a provider to this consultation.</span>
          </div>
          <div className='flex-container-column' style={{ alignItems: 'center', justifyContent: 'center', width: 200 }}>
            <Button value='Assign Provider'
                    onClick={ () => {
                      this.props.practiceActions.openReassignConsultation();
                    }}/>
          </div>
        </div> }
    </div>
  }

  renderResolvedPrice = (consultation) => {
    if (consultation.status !== 'RESOLVED') {
      return null;
    }

    let money_amount = StringUtils.displayMoney(consultation.final_amount);
    return <div className='flex-container-row' style={{ alignItems: 'center', marginTop: -5 }}>
      <span style={{ fontSize: 12, fontWeight: 'bold', color: '#1dc2ff', marginRight: 5 }}>RESOLVED: </span>
      <span style={{ fontSize: 13, color: '#66D56F' }}>{ ' ' +  money_amount }</span>
    </div>
  }

  renderConsultationScreenSections = (consultation) => {

    const primaryProvider = ArrayUtils.getSingleObject(consultation.assignee);
    const primaryClient   = ArrayUtils.getSingleObject(consultation.client);
    const patient         = ArrayUtils.getSingleObject(consultation.patient);
    const practice        = this.props.practice && this.props.practice.info ? this.props.practice.info : null;
    const patientName     = patient && patient.name ? patient.name : '';
    const clientName      = StringUtils.displayName(primaryClient);
    const loggedInUser    = this.props.user && this.props.user.users && this.props.user.users[this.props.user.auth.user_id] ? this.props.user.users[this.props.user.auth.user_id] : {};

    const genderKeys = {
      'MALE': 'Male',
      'FEMALE': 'Female',
      'MN': 'Male Neutered',
      'FS': 'Female Spayed',
    }

    var enhancedConsultation = Object.assign({}, consultation);
    enhancedConsultation.patient = patient;
    enhancedConsultation.primaryClient = primaryClient;
    enhancedConsultation.primaryProvider = primaryProvider;

    const showDetails = this.state.displayPatientDetails;

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        { this.renderAssignProviderSection(consultation) }
        <div className="basic-container">
          <h5>{ consultation.subject }</h5>

          { this.renderResolvedPrice(consultation) }

          <div className='flex-container-row flex-space-between' style={{ marginTop: 15 }}>
            { showDetails ? <span style={{ fontSize: 16 }}>Patient Details</span>
            :<div className='flex-container-row' style={{ alignItems: 'center' }}>
              { patient.photo_url ? <img className="image-default" style={{ height: 40, width: 40, borderRadius: 20, marginRight: 5 }} src={patient.photo_url} />
              : <div style={{ backgroundColor: '#e9e9e9', height: 40, width: 40, borderRadius: 20, marginRight: 5 }} className="flex-container flex-center-align flex-center-justify">
                  <span className="fas fa-horse" style={{ fontSize: 20, color: 'white' }}></span>
                </div>
              }
              <div className="flex-container-column" style={{ marginRight: 25  }}>
                <span style={{ fontSize: 15 }}>{ patient.name }</span>
                <span style={{ fontSize: 11, marginTop: -1, color: '#1dc2ff' }}>PET</span>
              </div>
              <div className="flex-container-column">
                <span style={{ fontSize: 15 }}>{ StringUtils.displayName(primaryClient) }</span>
                <span style={{ fontSize: 11, marginTop: -1, color: '#1dc2ff' }}>CLIENT</span>
              </div>
            </div>}

            <div>
              <input type='submit'
                     value={ showDetails ? 'HIDE DETAILS' : 'VIEW PATIENT DETAILS' }
                     className='button-clear-blue'
                     onClick={ () => { this.setState({ ...this.state, displayPatientDetails: !showDetails }) }}
                    />
            </div>
          </div>

        { this.state.displayPatientDetails
        ? <div className="flex-container flex-container-column">
            <div className="flex-container flex-container-row">
              <div>
                { patient.photo_url ? <img className="image-default" style={{ height: 80, width: 80, borderRadius: 40 }} src={patient.photo_url} />
                : <div style={{ backgroundColor: '#e9e9e9', height: 80, width: 80, borderRadius: 40 }} className="flex-container flex-center-align flex-center-justify">
                    <span className="fas fa-horse" style={{ fontSize: 40, color: 'white' }}></span>
                  </div>
                }
              </div>
              <div className="flex-container flex-container-column" style={{ width: '100%', paddingLeft: 20 }}>
                <div className="flex-container flex-container-row"  style={{ width: '70%', justifyContent: 'space-between' }}>
                  <div className="flex-container flex-container-column">
                    <span style={{ fontSize: 15 }}>{ patient.name }</span>
                    <span style={{ fontSize: 11, marginTop: -1, color: '#1dc2ff' }}>PET NAME</span>
                    <span style={{ fontSize: 15, marginTop: 5 }}>{ patient.type }</span>
                    <span style={{ fontSize: 11, marginTop: -1, color: '#1dc2ff' }}>PET TYPE</span>
                    <span style={{ fontSize: 15, marginTop: 5 }}>{ genderKeys[patient.gender] }</span>
                    <span style={{ fontSize: 11, marginTop: -1, color: '#1dc2ff' }}>PET GENDER</span>
                  </div>
                  <div className="flex-container flex-container-column">
                    <span style={{ fontSize: 15 }}>{ patient.age }</span>
                    <span style={{ fontSize: 11, marginTop: -1, color: '#1dc2ff' }}>PET AGE</span>
                    <span style={{ fontSize: 15, marginTop: 5 }}>{ patient.breed }</span>
                    <span style={{ fontSize: 11, marginTop: -1, color: '#1dc2ff' }}>PET BREED</span>
                    <span style={{ fontSize: 15, marginTop: 5 }}>{ StringUtils.displayName(primaryClient) }</span>
                    <span style={{ fontSize: 11, marginTop: -1, color: '#1dc2ff' }}>PET OWNER</span>
                  </div>
                </div>
              </div>
            </div>
          </div> : null }

        </div>
        { this.state.displayCall ? <VideoCall
                                      user={loggedInUser}
                                      users={this.props.user.users}
                                      token={this.props.user.auth.token}
                                      practice={practice}
                                      consultationId={consultation._id}
                                      consultation={consultation}
                                      endCallAction={this.toggleDisplayCall}
                                      videoCallActions={this.props.videoCallActions}
                                   />
                                 : this.renderBottomSection(enhancedConsultation) }
      </div>
    </div>
  }

  render() {

    const selectedConsultation = this.props.consultations && this.props.consultations.selectedConsultation ? this.props.consultations.selectedConsultation : {};
    var consultation =  this.props.consultations
                          && this.props.consultations.allConsultations
                          && this.props.consultations.allConsultations[selectedConsultation._id] ? this.props.consultations.allConsultations[selectedConsultation._id] : selectedConsultation;

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Consultation" />
        { this.renderConsultationScreenSections(consultation) }
        { this.renderImageModal() }
      </div>
    );
  }

  renderImageModal = () => {
    let image_url           = this.state.modal_image_url;
    let display_image_modal = this.state.display_image_modal;

    return <Modal dialogClassName='image-modal-dialog' style={{ backgroundColor: 'black' }} show={display_image_modal} onHide={ () => { this.setState({ ...this.state, display_image_modal: false, modal_image_url: '' }) }}>
      <div className='flex-container-column' style={{ display: 'flex', flexDirection: 'column', padding: 15, height: window.innerHeight - 70, backgroundColor: 'black' }}>
        <div className='flex-container-column' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', paddingRight: 20, marginBottom: 10, backgroundColor: 'black' }}>
          <Button value='Close Image' style={{ }} onClick={ () => { this.setState({ ...this.state, display_image_modal: false, modal_image_url: '' }) }} />
        </div>
        <img className="consultation-full-image" alt='Profile Pic of Client' style={{ maxHeight: '90%', width: '100%' }} src={image_url} />
      </div>
    </Modal>
  }

  handleFileUpload = (event) => {

    var file = event.target.files[0];
    var files = event.target.files;

    var mediaType = '';

    if (file && file.type === 'image/jpeg' || file.type === 'image/png') {
      mediaType = 'IMAGE'
    }

    if (file && file.type === 'video/mp4' || file.type === 'video/3gpp' || file.type === 'video/quicktime' || file.type === 'video/3gpp') {
      mediaType = 'VIDEO'
    }

    var reader = new FileReader();
    reader.onloadend = () => {
      this.setState({
        file: reader.result,
        toUpload: files,
        attachmentType: mediaType,
      });
    }
    reader.readAsDataURL(file);

  }

  submitFile = () => {

    const formData = new FormData();
    formData.append('file', this.state.toUpload[0]);

    fetch(`${config.BASE_URL}/api/file/chat`, {
      method: 'POST',
      headers: {
        'Authorization': this.props.user.auth.token,
      },
      body: formData,
    })
    .then((res) => {
      return res.json();
    })
    .then((body) => {

      const consultation = this.props.consultations && this.props.consultations.selectedConsultation ? this.props.consultations.selectedConsultation : {};
      const consultationID = consultation._id;

      if (consultationID) {
        this.socket.emit('chat message', {
          type: this.state.attachmentType,
          content: { url: body.message.Location },
          consultation_id: consultationID,
          from: this.props.user.auth.user_id
        });

        this.setState({ ...this.state, file: null, toUpload: null, attachmentType: null });
      }
    })
    .catch(error => {
      console.log("Error: " + error)
    });

  }

  sendMessage = () => {
    const message = this.state.message;
    const consultation = this.props.consultations && this.props.consultations.selectedConsultation ? this.props.consultations.selectedConsultation : {};
    const consultationID = consultation._id;
    const userId = this.props.user.auth.user_id;

    if (this.state.message && consultationID && userId) {
      this.socket.emit('chat message', {
        type: "TEXT",
        content: { text: this.state.message },
        consultation_id: consultationID,
        from: userId
      });
    }
  }

  toggleDisplayCall = () => {
    this.setState({ ...this.state, displayCall: !this.state.displayCall });
  }

  getLocationInfo = (location_id) => {
    if (!location_id) {
      return null;
    }

    const practiceLocations = this.props.practice && this.props.practice.locations ? this.props.practice.locations : {};
    const location = practiceLocations[location_id] || null;
    return location;
  }

  updateConsultationAppointments = (appointments_dict) => {
    this.setState({ ...this.state, appointments_dict: appointments_dict });
  }

  closeAppointmentModal = (token, consultation_id) => {
    this.props.scheduleActions.getConsultationAppointments(token, consultation_id, this.updateConsultationAppointments);
    this.setState({ ...this.state, displayAppointmentModal: false });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
    consultations: state.consultations,
    notifications: state.notifications,
    schedule: state.schedule,
    loading: state.loading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    consultationsActions: bindActionCreators(
     { ...ConsultationsActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    scheduleActions: bindActionCreators(
     { ...ScheduleActions }, dispatch),
    notificationsActions: bindActionCreators(
     { ...NotificationsActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch),
    videoCallActions: bindActionCreators(
     { ...VideoCallActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultationScreen)
